(function () {

  /* =====================================================
     FORMAT PRICE
     ===================================================== */

  function formatPrice(value) {
    return Math.round(Number(value || 0))
      .toLocaleString('en-IN');
  }


  /* =====================================================
     GET SLIDER ELEMENTS
     ===================================================== */

  function getParts(wrapper) {
    return {
      minSlider: wrapper.querySelector(
        '[data-pediteq-price-min]'
      ),

      maxSlider: wrapper.querySelector(
        '[data-pediteq-price-max]'
      ),

      minDisplay: wrapper.querySelector(
        '[data-pediteq-min-display]'
      ),

      maxDisplay: wrapper.querySelector(
        '[data-pediteq-max-display]'
      ),

      track: wrapper.querySelector(
        '.pediteq-price-slider__track'
      )
    };
  }


  /* =====================================================
     UPDATE DISPLAYED PRICE VALUES
     ===================================================== */

  function updateDisplay(wrapper, changedSlider) {

    const parts = getParts(wrapper);

    if (!parts.minSlider || !parts.maxSlider) {
      return;
    }


    let minValue = Number(parts.minSlider.value);
    let maxValue = Number(parts.maxSlider.value);


    /*
      Prevent minimum handle from
      crossing maximum handle.
    */

    if (minValue > maxValue) {

      if (changedSlider === parts.minSlider) {

        minValue = maxValue;

        parts.minSlider.value = maxValue;

      } else {

        maxValue = minValue;

        parts.maxSlider.value = minValue;

      }

    }


    if (parts.minDisplay) {
      parts.minDisplay.textContent =
        formatPrice(minValue);
    }


    if (parts.maxDisplay) {
      parts.maxDisplay.textContent =
        formatPrice(maxValue);
    }

  }


  /* =====================================================
     UPDATE BLACK / FADED TRACK
     ===================================================== */

  function updateTrack(wrapper) {

    const parts = getParts(wrapper);

    if (
      !parts.minSlider ||
      !parts.maxSlider ||
      !parts.track
    ) {
      return;
    }


    const minLimit =
      Number(parts.minSlider.min || 0);

    const maxLimit =
      Number(parts.maxSlider.max || 0);

    const minValue =
      Number(parts.minSlider.value);

    const maxValue =
      Number(parts.maxSlider.value);


    if (maxLimit <= minLimit) {
      return;
    }


    const minPercent =
      ((minValue - minLimit) /
        (maxLimit - minLimit)) * 100;


    const maxPercent =
      ((maxValue - minLimit) /
        (maxLimit - minLimit)) * 100;


    parts.track.style.setProperty(
      '--min-position',
      `${minPercent}%`
    );


    parts.track.style.setProperty(
      '--max-position',
      `${maxPercent}%`
    );

  }


  /* =====================================================
     INITIALISE ONE SLIDER
     ===================================================== */

  function initSlider(wrapper) {

    if (!wrapper) {
      return;
    }


    updateDisplay(wrapper);

    updateTrack(wrapper);

  }


  /* =====================================================
     INITIALISE ALL PRICE SLIDERS
     ===================================================== */

  function initAll() {

    document
      .querySelectorAll(
        '[data-pediteq-price-range]'
      )
      .forEach(function (wrapper) {

        initSlider(wrapper);

      });

  }


  /* =====================================================
     PAGE LOAD
     ===================================================== */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  /* Shopify theme editor */

  document.addEventListener(
    'shopify:section:load',
    initAll
  );


  /* =====================================================
     WHILE USER IS DRAGGING
     ===================================================== */

  document.addEventListener(
    'input',
    function (event) {

      const slider =
        event.target.closest(
          '[data-pediteq-price-min], [data-pediteq-price-max]'
        );


      if (!slider) {
        return;
      }


      const wrapper =
        slider.closest(
          '[data-pediteq-price-range]'
        );


      if (!wrapper) {
        return;
      }


      /*
        Update numbers immediately.
      */

      updateDisplay(
        wrapper,
        slider
      );


      /*
        Update black / grey track
        immediately while dragging.
      */

      updateTrack(wrapper);

    }
  );


  /* =====================================================
     WHEN USER RELEASES THE HANDLE
     APPLY SHOPIFY FILTER
     ===================================================== */

  document.addEventListener(
    'change',
    function (event) {

      const slider =
        event.target.closest(
          '[data-pediteq-price-min], [data-pediteq-price-max]'
        );


      if (!slider) {
        return;
      }


      const wrapper =
        slider.closest(
          '[data-pediteq-price-range]'
        );


      if (!wrapper) {
        return;
      }


      updateDisplay(
        wrapper,
        slider
      );


      updateTrack(wrapper);


      /* -----------------------------------------
         Find Shopify native price filter
         ----------------------------------------- */

      const panel =
        wrapper.closest(
          '.facets__panel-content'
        );


      if (!panel) {
        return;
      }


      const priceFacet =
        panel.querySelector(
          'price-facet-component'
        );


      if (!priceFacet) {
        return;
      }


      const nativeMin =
        priceFacet.querySelector(
          '[ref="minInput"]'
        );


      const nativeMax =
        priceFacet.querySelector(
          '[ref="maxInput"]'
        );


      if (!nativeMin || !nativeMax) {
        return;
      }


      /* -----------------------------------------
         Get custom slider values
         ----------------------------------------- */

      const parts = getParts(wrapper);


      const minValue =
        Number(parts.minSlider.value);


      const maxValue =
        Number(parts.maxSlider.value);


      const rangeMax =
        Number(parts.maxSlider.max);


      /* -----------------------------------------
         Pass values to Shopify
         ----------------------------------------- */


      /*
        When minimum is zero,
        leave Shopify minimum blank.
      */

      nativeMin.value =
        minValue > 0
          ? minValue.toFixed(2)
          : '';


      /*
        When maximum equals full range,
        leave Shopify maximum blank.
      */

      nativeMax.value =
        maxValue < rangeMax
          ? maxValue.toFixed(2)
          : '';


      /* -----------------------------------------
         Trigger Horizon's native AJAX filter
         ----------------------------------------- */

      if (
        typeof priceFacet
          .updatePriceFilterAndResults
          === 'function'
      ) {

        priceFacet
          .updatePriceFilterAndResults();

      } else {

        /*
          Fallback if the theme method
          isn't available.
        */

        nativeMin.dispatchEvent(
          new Event(
            'change',
            {
              bubbles: true
            }
          )
        );

      }

    }
  );


  /* =====================================================
     REINITIALISE AFTER SHOPIFY AJAX UPDATES
     ===================================================== */

  const observer =
    new MutationObserver(function (mutations) {

      let sliderAdded = false;


      mutations.forEach(function (mutation) {

        mutation.addedNodes.forEach(
          function (node) {

            if (
              node.nodeType !== 1
            ) {
              return;
            }


            if (
              node.matches &&
              node.matches(
                '[data-pediteq-price-range]'
              )
            ) {

              sliderAdded = true;

            }


            if (
              node.querySelector &&
              node.querySelector(
                '[data-pediteq-price-range]'
              )
            ) {

              sliderAdded = true;

            }

          }
        );

      });


      if (sliderAdded) {

        initAll();

      }

    });


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();